import React from 'react';
import { styled } from '@mui/material/styles';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Avatar,
    Menu,
    MenuItem,
    Tooltip,
    Badge
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SchoolIcon from '@mui/icons-material/School';
import logo from "../assets/colored_logo.png";

const DRAWER_WIDTH = 260;

const StyledAppBar = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: DRAWER_WIDTH,
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    backgroundColor: '#ffffff',
    color: theme.palette.primary.main,
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
}));

function Header({ open, onMenuClick }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleNotificationMenuOpen = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleNotificationMenuClose = () => {
        setNotificationAnchorEl(null);
    };

    return (
        <StyledAppBar position="fixed" open={open}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={onMenuClick}
                    edge="start"
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img src={logo} alt="School Management System" style={{ height: 40, marginRight: 12 }} />
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            fontWeight: 600,
                            color: '#333'
                        }}
                    >
                        Attendance Management System
                    </Typography>
                </Box>

                <Box sx={{ flexGrow: 1 }} />

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title="Notifications">
                        <IconButton
                            color="inherit"
                            size="large"
                            onClick={handleNotificationMenuOpen}
                        >
                            <Badge badgeContent={3} color="error">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Account">
                        <IconButton
                            edge="end"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                            size="large"
                            sx={{ ml: 2 }}
                        >
                            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
                                <AccountCircleIcon />
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                        elevation: 2,
                        sx: { minWidth: 200 }
                    }}
                >
                    <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
                    <MenuItem onClick={handleMenuClose}>Settings</MenuItem>
                    <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
                </Menu>

                <Menu
                    anchorEl={notificationAnchorEl}
                    open={Boolean(notificationAnchorEl)}
                    onClose={handleNotificationMenuClose}
                    PaperProps={{
                        elevation: 2,
                        sx: { minWidth: 300, maxWidth: 350 }
                    }}
                >
                    <MenuItem onClick={handleNotificationMenuClose}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SchoolIcon color="primary" sx={{ mr: 1.5 }} />
                            <Box>
                                <Typography variant="body2" fontWeight="medium">
                                    New attendance report ready
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    5 minutes ago
                                </Typography>
                            </Box>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={handleNotificationMenuClose}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SchoolIcon color="primary" sx={{ mr: 1.5 }} />
                            <Box>
                                <Typography variant="body2" fontWeight="medium">
                                    Bus 103 arrived at school
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    20 minutes ago
                                </Typography>
                            </Box>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={handleNotificationMenuClose}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SchoolIcon color="primary" sx={{ mr: 1.5 }} />
                            <Box>
                                <Typography variant="body2" fontWeight="medium">
                                    Staff meeting scheduled
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    1 hour ago
                                </Typography>
                            </Box>
                        </Box>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </StyledAppBar>
    );
}

export default Header;